import $ from "jquery";
import plugin from '@core/plugins/lib';
import debug from "debug";
import { GAServices } from "../../services/ga-services";
import { KlaviyoServices } from "../../services/klaviyo-services";
const MODULE_NAME = 'app.core/modules/ga-tracking-event';
const log = debug(MODULE_NAME);

log('registerd');

class GaTrackingEvent {
	constructor(element, options) {
		this.element = element;
		this.$element = $(element);
		this.currency = $('body').data('currency');
		this.type = this.$element.data('type');
		this.watch();
	}

	watch () {
		if (this.type === 'PDP') {
			const product = window.datalayerDataSource;
			if (product) {
				const dataItemList = GAServices.getItemListName(product.item_id);
				const dataTracking = {
					event: 'view_item',
					ecommerce: {
						currency: this.currency,
						items: [],
					}
				};
				const item = Object.assign({}, product, dataItemList);
				item.quantity = undefined;
				item.status = item.status || undefined;
				dataTracking.ecommerce.items.push(item);
				GAServices.trackingGA(dataTracking);

				// Click event on select color
				const $colours = this.$element.find('[ga-tracking-link]');
				$colours.each((index, color) => {
					$(color).on('click', (e) => {
						const newData = GAServices.getAttributesWithPrefix($(color), 'data-ga-');
						const colorData = Object.assign({}, item, newData);
						GAServices.saveListItemsName(colorData);
					});
				});
			}
			// Klaviyo track Viewed Product event
			const klaviyoProduct = window.klaviyoDataSource;
			if(klaviyoProduct) {
				KlaviyoServices.trackingKlaviyo('Viewed Product', klaviyoProduct);
				KlaviyoServices.trackViewedItem(klaviyoProduct);
			}

		} else if (this.type === 'Cart Submitted') {
			const cartInfo = window.datalayerDataSource;
			const savedOrderId = localStorage.getItem('orderIdTracking');
			if (cartInfo && !savedOrderId) {
				const data = JSON.parse(localStorage.getItem('cartTrackingData')) || [];
				cartInfo.items = data;
				const dataTracking = {
					event: 'purchase',
					ecommerce: cartInfo,
				};
				GAServices.trackingGA(dataTracking);
				localStorage.setItem('orderIdTracking', cartInfo.transaction_id);
				const url = this.$element.data('ga-tracking-sent-api-url');
				const orderId = this.$element.data('order-id');
				const urlPost = url + `?purchaseOrderId=${orderId}&value=1`;
				const token = $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]').val();
				fetch(urlPost, {
					method: "POST",
					body: JSON.stringify({
						__RequestVerificationToken: token,
					}),
					headers: {
						"Content-Type": "application/json",
					},
				}).then((response) => {
					localStorage.removeItem('selectTrackingData');
					localStorage.removeItem('cartTrackingData');
					localStorage.removeItem('cartKlaviyoTrackingData');
				});
			}
		}
	}
}

GaTrackingEvent.DEFAULTS = {};

export default GaTrackingEvent;



// WEBPACK FOOTER //
// ./client/src/core/components/ga-tracking-event/ga-tracking-event.js